import {
	addClassDuringActivity,
	initBlockEnterKeyForDisabledButton,
	setButtonStateDuringActivity
} from 'utilities/dom';
import { addToCart, redirectToCart } from 'features/cart';
import { showAddToCartFailureModal } from 'features/cart/desktop';
import { addToWishList, showAddToWishListError } from 'features/wishList/desktop';
import { formatCurrency } from 'utilities/localization';
import { utagLinkRoomViewer } from 'features/tealium';
import { trackAddToCartDy } from 'features/tealium/dynamicYield';
import LPGlider from 'ui/glider';

const CAROUSEL_SLIDESTOSHOW = 5;

if (window.location.href.indexOf('/viewer/rooms/')) {

	window.lp.dataCapture.pageLevelData.pageTypeId = '34';

}

function getShortSkuArrayForGa (products) {

	if (!Array.isArray(products)) {

		return [];

	}

	const shortSkus = products.reduce((acum, product) => {

		for (let i = 0; i < product.Quantity; i++) {

			acum.push(product.ShortSku);

		}
		return acum;

	}, []);
	return shortSkus.length ? shortSkus : '';

}

const trackViewInYourRoom = utagLinkRoomViewer();
lp.ar.Layout = Backbone.Marionette.LayoutView.extend({
	template: '/augmented-reality/templates/layout',
	regions: {
		headerRegion: '#arHeader',
		sidebarRegion: '#arSidebar',
		bodyRegion: '#arMain',
		noteRegion: '#arNote',
		footerRegion: '#arFooter'
	},
	initialize () {

		const that = this;
		const clearScene = function () {

			that.model.clear({ silent: true });
			lp.ar.canvas.renderScene();
			$(lp.ar).trigger('emptyScene');
			that.headerRegion.currentView.render();
			that.sidebarRegion.currentView.render();
			that.footerRegion.currentView.render();

		};
		const sceneChange = function (_, skipRenderFooter) {

			// sometimes we need some preparations before save
			// so we use this flag to avoid default behavior: immediatly save on every 'change' event
			if (lp.ar.skipLoad) {

				return;

			}

			if (lp.ar.canvas.undo === undefined) {

				lp.ar.canvas.undo = [];

			}

			that.headerRegion.currentView.render();
			that.sidebarRegion.currentView.render();

			if (!skipRenderFooter) {

				that.footerRegion.currentView.render();

			}

			/*
			 * Saving Scene
			 */

			if (lp.ar.saveQueue === 0) {

				$(lp.ar).trigger('messageAlert', { message: 'Saving changes...', fast: true });

			}

			lp.ar.saveQueue++;

			that.model.save(lp.ar.loadSceneModel(that.model), {
				success () {

					$(lp.ar).trigger('savedScene');

					lp.ar.saveQueue--;

					if (lp.ar.saveQueue === 0) {

						$(lp.ar).trigger('messageAlert', { message: 'All changes auto saved', fast: false });

					}

					that.headerRegion.currentView.render();
					that.sidebarRegion.currentView.render();

					if (!skipRenderFooter) {

						that.footerRegion.currentView.render();

					}

				},
				error () {

					lp.ar.saveQueue--;

					if (lp.ar.saveQueue === 0) {

						$(lp.ar).trigger('messageAlert', { saveFailed: true });

					}

				},
				silent: true
			});
			/*
			 * End Saving Scene
			 */

		};

		$(lp.ar).on('fetchingScene', () => {

			if (lp.ar.firstFetch) {

				/** render body only first time, otherwise it will re-render over svg and clear it out * */
				that.bodyRegion.currentView.render();
				lp.ar.canvas.startScene(that.model);

			} else {

				lp.ar.canvas.renderScene(that.model);

			}

			lp.ar.firstFetch = false; // set to false after first scene fetch, so that we only start scene once, otherwise a new svg element will be created each time

			that.headerRegion.currentView.render();
			that.sidebarRegion.currentView.render();

			// Render Notes view if available
			if (that.noteRegion.currentView) {

				that.noteRegion.currentView.render();

			}

			that.footerRegion.currentView.render();

			// must rebind change event to model
			that.listenTo(that.model, 'change', () => sceneChange());

		});

		$(lp.ar).on('clearScene', clearScene);
		$(lp.ar).on('sceneChange', sceneChange);
		$(lp.ar).on('reloadHeader', () => {

			that.headerRegion.currentView.render();

		});
		$(lp.ar).on('reloadFooter', () => {

			that.footerRegion.currentView.render();

		});

	},
	onRender () {

		this.headerRegion.show(new lp.ar.HeaderItemView({ model: this.model }));
		this.sidebarRegion.show(new lp.ar.SidebarItemView({ model: this.model }));
		this.bodyRegion.show(new lp.ar.MainItemView({ model: this.model }));

		// Show Notes for CSRs only
		if (window.lp.globals.isCustomerService) {

			this.noteRegion.show(new lp.ar.NoteItemView({ model: this.model }));

		}

		this.footerRegion.show(new lp.ar.FooterItemView({ model: this.model, initialRender: true }));

	}
});

lp.ar.HeaderItemView = Backbone.Marionette.ItemView.extend({
	template: '/augmented-reality/templates/header',
	ui: {
		sceneTitle: '.arPageTitle',
		error: '.error'
	},
	onAttach () {

		this.initPageTitle();

	},
	onDomRefresh () {

		this.initPageTitle();
		this.hideError();

	},
	showHeaderError (msg) {

		$(this.ui.error).html(`<span>${msg}</span>`);
		$('.arContainer').addClass('headerError');

	},
	hideError () {

		$(this.ui.error).html('');
		$('.arContainer').removeClass('headerError');

	},
	initialize () {

		const that = this;

		$(lp.ar)
			.on('showHeaderError', (e, options) => {

				that.showHeaderError(options.message);

			})
			.on('hideHeaderError', () => {

				that.hideError();

			});

	},
	initPageTitle (e) {

		const that = this;
		const sceneName = $(this.ui.sceneTitle);

		lp.ar.initContentEditable(
			$(this.ui.sceneTitle),
			{
				suppressStatusMessage: true, // the success/error message will be displayed in another location
				onBeforeSubmit (e, options) {

					if (!that.model.get('Token')) {

						// if renaming an empty scene
						that.model.set({ SceneName: $.trim(sceneName.text()), IsOwnerOfAsset: true }); // owner must be set to true, otherwise if there's a naming conflict, it will return incorrect error response
						$(lp.ar).trigger('messageAlert', { message: 'Updating...', fast: false });
						return false;

					}

					options.ajaxData = {
						SceneName: $.trim(sceneName.text()),
						VersionNumber: that.model.get('VersionNumber'),
						LastAccessedDate: that.model.get('LastAccessedDate')
					};
					options.submitUrl = `/api/myscenes/scene/operation/rename/${that.model.get('Token')}/`;

					$(lp.ar).trigger('messageAlert', { message: 'Updating...', fast: false });

					return true;

				},
				onAjaxSuccessCustom () {

					$(lp.ar).trigger('sceneChange');
					$(lp.ar).trigger('messageAlert', { message: 'All changes auto saved', fast: false });
					that.model.set('VersionNumber', that.model.get('VersionNumber') + 1, { silent: true });

				},
				onAjaxErrorCustom (error) {

					$(lp.ar).trigger('messageAlert', { message: error, fast: false });

				}
			},
			this.model
		);

	},
	templateHelpers () {

		let totalQty = 0;

		// calculate total quantity of products
		_.each(this.model.get('Products'), (item) => {

			totalQty += item.Quantity;

		});

		return { totalQty };

	}
});

lp.ar.SidebarItemView = Backbone.Marionette.ItemView.extend({
	template: '/augmented-reality/templates/sidebar',
	ui: {
		controls: '.arControls .control',
		arBtn: '.arControls .arBtn',
		arBtnFirst: '.arControls__bottom .arBtn:first-child',
		arBtnLast: '.arControls__bottom .arBtn:last-child',
		forwardBtn: '.forward',
		backBtn: '.back',
		hideBtn: '.hide',
		deleteBtn: '.delete',
		deselectBtn: '.deselect',
		duplicateBtn: '.duplicate',
		undo: '.undo',
		email: '.email',
		print: '.print',
		roomOptionsSelector: '#arRoomOptions',
		newScene: '.newScene',
		openScene: '.openScene',
		duplicateScene: '.duplicateScene',
		publishScene: '.publishScene',
		share: '.share',
		backToProduct: '.backToProduct',
		addToCart: '.addSelectedCart',
		addToWishList: '.addToList',
		atcList: '.atcList',
		changeRoomPhoto: '.changeRoomPhoto',
		startNewRoom: '.startNewRoom',
		scrollableRoomOptions: '.arControls__bottom',
		flipHorizontallyBtn: '.flipHorizontally'
	},
	events: {
		'click @ui.addToCart[aria-disabled="false"]': 'addToCart',
		'click @ui.addToWishList[aria-disabled="false"]': 'addToWishList',
		'click @ui.backToProduct[aria-disabled="false"]': 'backToProduct',
		'click @ui.forwardBtn[aria-disabled="false"]': 'goForward',
		'click @ui.backBtn[aria-disabled="false"]': 'goBack',
		'click @ui.hideBtn[aria-disabled="false"]': 'hideProduct',
		'click @ui.deleteBtn[aria-disabled="false"]': 'goDelete',
		'click @ui.deselectBtn[aria-disabled="false"]': 'goDeselect',
		'click @ui.flipHorizontallyBtn[aria-disabled="false"]': 'goFlipHorizontally',
		'click @ui.duplicateBtn[aria-disabled="false"]': 'goDuplicate',
		'click @ui.undo[aria-disabled="false"]': 'undo',
		'click @ui.email[aria-disabled="false"]': 'emailScene',
		'click @ui.print[aria-disabled="false"]': 'printScene',
		'click @ui.changeRoomPhoto[aria-disabled="false"]': 'changeBackground',
		'click @ui.share[aria-disabled="false"]': 'shareScene',
		'click @ui.newScene[aria-disabled="false"]': 'newScene',
		'click @ui.duplicateScene[aria-disabled="false"]': 'duplicateScene',
		'click @ui.openScene[aria-disabled="false"]': 'openScene',
		'click @ui.publishScene[aria-disabled="false"]': 'publishScene',
		'focus @ui.arBtnFirst': 'scrollRoomOptionsToTop',
		'focus @ui.arBtnLast': 'scrollRoomOptionsToBottom'
	},
	templateHelpers () {

		const that = this;
		let totalQty = 0;
		const limitReached = lp.ar.getTotalSprites(that.model.get('Products')) >= 9;

		// calculate total quantity of products
		window._.each(this.model.get('Products'), (item) => {

			totalQty += item.Quantity;

		});

		return {
			LastSearch: window.lp.globals.lastSearchURL,
			isPublishable () {

				return (
					window.lp.globals.isCustomerService
					&& window.lp.globals.isEmployeeConnectedAsCustomer
					&& that.model.get('IsOwnerOfAsset')
				);

			},
			isShareDisabled () {

				return (
					window.lp.globals.isHospitality
					|| !!(
						!that.model.get('BackgroundImage')
						&& (_.isUndefined(that.model.get('Products')) || !that.model.get('Products').length)
					)
				);

			},
			isSceneEmpty () {

				return !that.model.get('Token');

			},
			disableDelete () {

				return !(that.model.get('Token') && that.model.get('IsOwnerOfAsset'));

			},
			noOtherScenes () {

				return !!(that.model.get('SceneCount') === 0 && !that.model.get('Token'));

			},
			limitReached () {

				return limitReached;

			},
			totalQty,
			isHospitality () {

				return window.lp.globals.isHospitality;

			},
			shareableScene () {

				return !!(
					that.model.get('BackgroundImage')
					|| (that.model.get('Products') && that.model.get('Products').length)
				);

			},
			activeScene () {

				return !!that.model.get('Token');

			}
		};

	},
	initialize () {

		$(lp.ar)
			.on('spriteSelected', (e, data) => {

				this.spriteControls(data);

			})
			.on('setUndo', () => {

				this.ui.undo.attr('aria-disabled', false);

			})
			.on('unsetUndo', () => {

				this.ui.undo.attr('aria-disabled', true);

			})
			.on('setDuplicate', () => {

				this.ui.duplicateBtn.attr('aria-disabled', false);

			});

	},
	onRender () {

		const spriteData = lp.ar.canvas.getOptions();
		this.spriteControls(spriteData);

		if (lp.ar.canvas.undo && lp.ar.canvas.undo.length > 0) {

			$(lp.ar).trigger('setUndo');

		}

		this.ui.atcList.each((_, btn) => initBlockEnterKeyForDisabledButton(btn));

	},
	spriteControls (data) {

		// sets the controls for the selected sprite
		this.ui.controls.attr('aria-disabled', true);

		// removes previous image
		this.ui.backToProduct.empty().attr({
			'aria-disabled': true,
			'aria-hidden': true,
			tabindex: -1 // make it not tabbable since element is empty without width and height
		});

		// reset add to cart and wish list
		this.ui.atcList.attr('aria-disabled', true);

		if (!data) {

			return;

		}

		if (data.image) {

			const imageSource = data.image.replace('&flip=lr', '');
			this.ui.backToProduct.html(`<img src="${imageSource}" width="80" height="80" alt="" />`).attr({
				'aria-disabled': false,
				'aria-hidden': false,
				tabindex: 0
			});
			this.ui.atcList.attr('aria-disabled', false);

		}

		if (data.forward) {

			this.ui.forwardBtn.attr('aria-disabled', false);

		}
		if (data.back) {

			this.ui.backBtn.attr('aria-disabled', false);

		}
		if (data.del) {

			this.ui.deleteBtn.attr('aria-disabled', false);

		}

		if (data.deselect) {

			this.ui.deselectBtn.attr('aria-disabled', false);

		}

		if (data.duplicate) {

			this.ui.duplicateBtn.attr('aria-disabled', false);

		}

		if (data.hide) {

			this.ui.hideBtn.attr('aria-disabled', false);

		}
		if (data.flipHorizontally) {

			this.ui.flipHorizontallyBtn.attr('aria-disabled', false);

		}

	},
	goForward () {

		lp.ar.canvas.moveUp(undefined, (context) => {

			trackViewInYourRoom({
				eventAction: 'Click-Move Item Forward',
				eventLabel: context.sku || ''
			});

		});

	},
	goBack () {

		lp.ar.canvas.moveDown(undefined, (context) => {

			trackViewInYourRoom({
				eventAction: 'Click-Move Item Back',
				eventLabel: context.sku || ''
			});

		});

	},
	hideProduct () {

		lp.ar.canvas.hideElement(
			{
				element: null
			},
			(context) => {

				const { spriteId } = context;

				lp.ar.canvas.updateIsHiddenState({
					spriteId,
					isHidden: true,
					model: this.model
				});

				trackViewInYourRoom({
					eventAction: 'Click-Hide Item',
					eventLabel: context.sku || ''
				});

			}
		);

	},
	goFlipHorizontally () {

		const currentEle = $.extend(true, [], this.model.get('Products'));
		lp.ar.canvas.undo.push(currentEle);
		// undo can only go up to 10 moves
		if (lp.ar.canvas.undo.length > 10) {

			lp.ar.canvas.undo.shift();

		}

		const selectedEle = lp.ar.canvas.getSelected().element;
		selectedEle.IsFlipped = !selectedEle.IsFlipped;
		const { spriteId, IsFlipped } = selectedEle;

		lp.ar.canvas.updateFlipState({
			spriteId,
			isFlipped: IsFlipped,
			model: this.model
		});

	},
	goDelete () {

		lp.ar.canvas.removeElement(
			{
				element: null
			},
			(context) => {

				trackViewInYourRoom({
					eventAction: 'Click-Remove Item',
					eventLabel: context.sku || ''
				});

			}
		);
		$(lp.ar).trigger('canvasChange');

	},
	goDuplicate () {

		lp.ar.canvas.duplicate((context) => {

			$(lp.ar).trigger('canvasChange');
			this.ui.duplicateBtn.attr('aria-disabled', true);
			trackViewInYourRoom({
				eventAction: 'Click-Duplicate Item',
				eventLabel: context.sku || ''
			});

		});

	},
	goDeselect () {

		lp.ar.canvas.selectElement(false);

	},

	undo () {

		$(lp.ar).trigger('undo');

	},
	emailScene () {

		$(lp.ar).trigger('emailScene');

	},
	printScene () {

		$(lp.ar).trigger('printScene');

	},
	roomOptionsChanged (e) {

		const optionsDropdown = e.target;
		this[optionsDropdown.value]();
		optionsDropdown.selectedIndex = 0;
		optionsDropdown.blur();
		$(e.target).blur();

	},
	checkMaxSceneCount () {

		return this.model.get('SceneCount') >= 50;

	},
	newScene () {

		const that = this;
		const shortSkuArray = getShortSkuArrayForGa(this.model.get('Products'));

		trackViewInYourRoom({
			eventAction: 'Click-Start a New Room',
			eventLabel: shortSkuArray
		});

		if (that.checkMaxSceneCount()) {

			$(lp.ar).trigger('maxSceneReachedOnSave');

		} else {

			lp.ar.showBackgroundModal('?new=true');

		}

	},
	openScene () {

		trackViewInYourRoom({
			eventAction: 'Click-Open a Saved Room',
			eventLabel: getShortSkuArrayForGa(this.model.get('Products'))
		});
		lp.ar.showManageScenes();

	},
	changeBackground () {

		trackViewInYourRoom({
			eventAction: 'Click-Change Room Photo',
			eventLabel: getShortSkuArrayForGa(this.model.get('Products'))
		});
		lp.ar.showBackgroundModal();

	},
	duplicateScene () {

		const that = this;

		trackViewInYourRoom({
			eventAction: 'Click-Duplicate This Room',
			eventLabel: getShortSkuArrayForGa(this.model.get('Products'))
		});

		if (that.checkMaxSceneCount()) {

			$(lp.ar).trigger('maxSceneReachedOnSave');

		} else {

			$('body').lpModal({
				onInit: true,
				width: 350,
				height: 150,
				appendContentToForm: false,
				openEvt () {

					$('#duplicateModal .cancel').on('click', (e) => {

						e.preventDefault();
						$('body').lpModalClose();

					});

					$('#duplicateModal .save').on('click', (e) => {

						e.preventDefault();

						/** Must pass IsOwnerOfAsset as true when duplicating, otherwise if there is a name conflict, it will return Conflict error instead of DuplicateSceneName error
						 * */

						that.model.save(
							lp.ar.loadSceneModel(that.model, { Token: '', sceneName: '', IsOwnerOfAsset: true }),
							{
								success () {

									$('body').lpModalClose();
									window.lp.utils.getAssetCounts();

								},
								error () {

									$(lp.ar).trigger('showError', { message: lp.ar.errorMessages.SceneCreation });

								},
								silent: true,
								wait: true
							}
						);

					});

				},

				closeEvt () {

					const form = $('.arContainer .lpForm');

					$('#duplicateModal .cancel, #duplicateModal .save').off();
					form.removeClass('error').find('label.error').html('');
					form.find('input').off();
					Backbone.history.loadUrl();

				},
				content: $('#duplicateModal')
			});

		}

	},
	publishScene () {

		this.model.publishToCustomer();

	},
	$shareModalContent: null,
	shareSceneData: null,
	getShareSceneData (data) {

		this.shareSceneData = data;

	},
	shareScene () {

		const $content = $('#shareModal');

		trackViewInYourRoom({
			eventAction: 'Click-Share This Room',
			eventLabel: getShortSkuArrayForGa(this.model.get('Products'))
		});

		// trigger fetching share data here versus on individual clicks to avoid pop-up blockers for async requests.
		this.updateSocialMedia();

		// append back HTML IE has oblitered from the DOM. Other browsers should ignore this
		if ($content.children().length === 0) {

			$content.append(this.$shareModalContent);

		}

		$('body').lpModal({
			onInit: true,
			width: 360,
			height: 230,
			appendContentToForm: false,
			openEvt: () => {

				$('#shareModal li').on('click keydown', (e) => {

					if (e.type === 'keydown' && e.keyCode !== 13) {

						return;

					}

					this[$(e.currentTarget).attr('data-click')]();
					// track which share platform is clicked
					if (e.currentTarget.dataset.sharePlatform) {

						trackViewInYourRoom({
							eventAction: `Share-${e.currentTarget.dataset.sharePlatform}`,
							eventLabel: getShortSkuArrayForGa(this.model.get('Products'))
						});

					}

				});

			},
			closeEvt () {

				$('#shareModal li').off();

			},
			content: $('#shareModal')
		});

	},
	updateSocialMedia () {

		const that = this;

		$.ajax({
			url: '/api/myscenes/currentscene/operation/shareonsocialmedia',
			type: 'POST',
			success (data) {

				if (data.OperationResponse && !data.OperationResponse.IsSuccessful) {

					$('body').lpModalClose();
					lp.ar.processError(data.OperationResponse, that.model);

				} else {

					data.MySceneUrl = window.lp.globals.secureSiteURL + data.MySceneUrl;
					return that.getShareSceneData(data);

				}

			},
			error () {

				$(lp.ar).trigger('messageAlert', { message: 'Error', fast: false });

			}
		});

	},
	clickPinterest () {

		const pinterestUrl = 'https://www.pinterest.com/pin/create/button?';
		const that = this;
		const data = that.shareSceneData;
		const params = {
			url: data.MySceneUrl,
			media: data.ShortImageUrl,
			description:
				'See how lighting looks in your room before you buy - Room Viewer from Lamps Plus. Upload a photo of your room - View up to 5 products on one background.'
		};
		window.open(pinterestUrl + $.param(params), 'Pin it', 'height=400, width=767, top=200, left=500');

	},
	clickFacebook () {

		const that = this;
		const data = that.shareSceneData;

		if (window.FB) {

			const url = data.MySceneUrl || window.location.href;
			window.FB.ui(
				{
					method: 'feed',
					link: url,
					picture: data.ShortImageUrl,
					// force pop up for FB account users
					display: 'popup',
					name: 'Hello, look at the virtual room I just built on Lamps Plus!',
					description:
						'See how lighting looks in your room before you buy - Room Viewer from Lamps Plus. Upload a photo of your room - View up to 5 products on one background.',
					caption: 'Check out my room! Visit LampsPlus.com and #MyRoomPlanner'
				},
				() => {}
			);

		}
		return false;

	},
	clickTwitter () {

		const twitterUrl = 'https://twitter.com/share?';
		const that = this;
		const data = that.shareSceneData;
		const params = {
			text: 'Check this room I made. See lighting & decor in place before you buy!',
			url: data.MySceneUrl,
			via: 'LampsPlus\n',
			hashtags: '\nMyRoomPlanner\n'
		};
		window.open(twitterUrl + $.param(params), 'Tweet', 'height=350, width=500, top=200, left=500');

	},
	addToWishList (e) {

		const products = [];
		const $el = $(e.target).closest('.addToList[aria-disabled="false"]');
		const selected = lp.ar.canvas.getSelected();
		const product = this.model
			.get('Products')
			.filter((el) => el.ShortSku.toLowerCase() === selected.element.shortSku.toLowerCase())[0];

		const { Quantity, ShortSku } = product;

		products.push({
			Quantity,
			ShortSku
		});

		trackViewInYourRoom({
			eventAction: 'Save-To-Wishlist',
			eventLabel: getShortSkuArrayForGa(this.model.get('Products'))
		});

		const request = addToWishList(
			products,
			() => {

				document.location.href = '/wish-list/';

			},
			(maxItemCountReached) => {

				showAddToWishListError(maxItemCountReached);

			},
			undefined,
			true
		);
		addClassDuringActivity($el.get(0), 'loading noPointerEvents disabled', request);

	},
	addToCart (e) {

		const products = [];
		const $el = $(e.target).closest('.addSelectedCart[aria-disabled="false"]');
		const { reporter } = window.lp.dataCapture;
		const button = $el.get(0);
		const testCompositionId =			(window.utag_data.testcomposition_id && window.utag_data.testcomposition_id[0]) || null;
		const selected = lp.ar.canvas.getSelected();
		const product = this.model
			.get('Products')
			.filter((el) => el.ShortSku.toLowerCase() === selected.element.shortSku.toLowerCase())[0];

		const {
			Quantity, ShortSku, ProductName, DisplayPrice, Category, SkuInputType
		} = product;

		products.push({
			Quantity,
			ShortSku,
			TestCompositionId: testCompositionId,
			Name: ProductName,
			Price: DisplayPrice,
			Category,
			SkuInputType
		});

		const request = addToCart({
			arrData: products,
			successCallback: redirectToCart,
			errorCallback: (errors, xhr, response) => {

				showAddToCartFailureModal({
					cartStatus: errors,
					response,
					fromModal: false
				});

			}
		});

		if (window.lp.globals.enableDataCapture) {

			reporter.trackAddToCart(products, button);

		}

		if (window.top.DY) {

			try {

				trackAddToCartDy(ShortSku, DisplayPrice * Quantity, Quantity);

			} catch (e) {

				console.warn('DY API is not available', e);

			}

		}

		addClassDuringActivity(button, 'loading noPointerEvents disabled', request);

	},
	backToProduct () {

		const selected = lp.ar.canvas.getSelected();
		trackViewInYourRoom({
			eventAction: 'Click-Back to Product',
			eventLabel: getShortSkuArrayForGa(this.model.get('Products'))
		});
		document.location.href = `/p/${selected.element.shortSku}`;

	},
	scrollRoomOptionsToTop () {

		const scrollableElement = this.ui.scrollableRoomOptions[0];
		scrollableElement.scrollTop = 0;

	},
	scrollRoomOptionsToBottom () {

		const scrollableElement = this.ui.scrollableRoomOptions[0];
		scrollableElement.scrollTop = scrollableElement.scrollHeight;

	}
});

lp.ar.MainItemView = Backbone.Marionette.ItemView.extend({
	template: '/augmented-reality/templates/main',
	ui: {
		linkToSpec: '.linkToSpecialist',
		messageAlert: '.messageAlert',
		canvas: '#arCanvas'
	},
	events: {
		'click @ui.linkToSpec': 'linkToSpec',
		'mousedown @ui.canvas': 'canvasChange',
		'touchend @ui.canvas': 'canvasChange',
		'click #helpers .close': 'closeHelper',
		'click #helpers .bottomClose': 'closeHelper2',
		'click #retrySaveBtn': 'retrySave'
	},
	templateHelpers () {

		return {
			loggedOut: !window.lp.globals.isLoggedIn,
			isCurrentSessionShared: window.lp.globals.isCurrentSessionShared,
			isHospitality () {

				return window.lp.globals.isHospitality;

			},
			displayPhoneNumber () {

				return window.lp.globals.consultantPhoneNumber;

			},
			maxCount () {

				return lp.ar.maxCount;

			}
		};

	},
	linkToSpec (e) {

		e.preventDefault();

		$('body').lpModal({
			onInit: true,
			width: 470,
			height: 450,
			appendContentToForm: false,
			src: `${lp.ar.path}/DesignWithSpecialist`,
			preCloseEvt () {

				if ($('#modalIframe').contents().find('.thankyou').length) {

					window.location.reload();

				}
				return true;

			}
		});

		return false;

	},
	initialize () {

		/** this * */
		const that = this;

		$(lp.ar).on('maxSceneReachedOnSave', () => {

			$('#lpContainer').addClass('loaded');
			lp.ar.skipLoad = true;
			that.showMaxSceneModal();

		});

		/** AR Events * */
		$(lp.ar)
			.on('canvasChange', () => {

				// prevents empty scenes from being saved on canvas click
				if (that.model.get('Token')) {

					const sprites = lp.ar.canvas.setSprites();
					const updatedProducts = [];
					const products = $.extend(true, [], that.model.get('Products'));
					const data = lp.ar.canvas.getOptions();

					// Filter sprites by short sku and insert them into each product
					for (let i = 0; i < products.length; i++) {

						const filtered = $.map(sprites, (val) => {

							if (val.ShortSku === products[i].ShortSku) {

								return val;

							}

						});

						if (filtered.length > 0) {

							products[i].ProductSprites = filtered;
							updatedProducts.push(products[i]);

						}

					}

					if (!_.isEqual(that.model.get('Products'), updatedProducts)) {

						// add snapshot of all products to undo array
						lp.ar.canvas.undo.push(that.model.get('Products'));
						// undo can only go up to 10 moves
						if (lp.ar.canvas.undo.length > 10) {

							lp.ar.canvas.undo.shift();

						}

					}

					// set products to trigger save
					that.model.set('Products', updatedProducts);

					// Trigger event to select element
					$(lp.ar).trigger('spriteSelected', data);

					if (_.isNull(that.model.get('BackgroundImage')) && !sprites.length) {

						$(lp.ar).trigger('emptyScene');

					}

				}

			})
			.on('messageAlert', (e, options) => {

				if (options.saveFailed) {

					$(that.ui.messageAlert)
						.addClass('err')
						.hide()
						.html(
							'<span>Sorry, your last edit wasn\'t saved - <button type="button" id="retrySaveBtn" class="anchorLink">Save Now</button></span>'
						)
						.fadeIn();

				} else if (options.fast) {

					$(that.ui.messageAlert).removeClass('err').html(`<span>${options.message}</span>`);

				} else {

					$(that.ui.messageAlert).removeClass('err').hide().html(`<span>${options.message}</span>`)
						.fadeIn();

				}

			})
			.on('emptyScene', () => {

				lp.ar.isSceneEmpty = true;
				lp.ar.canvas.undo = [];
				$(lp.ar).trigger('spriteSelected');
				$(lp.ar).trigger('unsetUndo');
				if ($('#helpers .item .linkToSpecialist').length && $('.boldchatPosition').length) {

					$('#helpers .item .linkToSpecialistWrapper .orText').addClass('showText');

				}
				$('#helpers .item .linkToSpecialistWrapper').append($('.boldchatPosition'));

				$('#helpers .item').show(); // show help icons on empty scene
				$('.boldchatPosition').show();
				$('#lpContainer').addClass('loaded');

			})
			.on('fullScene', () => {

				lp.ar.isSceneEmpty = false;
				lp.ar.canvas.undo = [];
				$(lp.ar).trigger('unsetUndo');
				$('#helpers .item').hide(); // hide help icons on load
				$('.boldchatPosition').hide();
				$('#lpContainer').addClass('loaded');

			})
			.on('limitReached', (e, sku) => {

				that.showLimitModal(sku);

			})
			.on('hasConcurrencyConflict', () => {

				that.showConcurrencyModal();

			})
			.on('showError', (e, options) => {

				that.showError(options);

			})
			.on('sceneNotFound', (e, options) => {

				that.sceneNotFound(options);
				$('#lpContainer').addClass('loaded');

			})
			.on('UnauthorizedAction', (e, opts) => {

				opts.model.clear({ silent: true });
				Backbone.history.loadUrl();

			})
			.on('InvalidSpritesData', () => {

				this.showInvalidSpritesDataModal();
				lp.ar.canvas.renderScene(this.model);

			})
			.on('undo', () => {

				this.undo();

			})
			.on('printScene', () => {

				this.printScene();

			})
			.on('saveScene', () => {

				this.saveScene();

			})
			.on('emailScene', () => {

				this.emailScene();

			});

	},
	retrySave () {

		$(lp.ar).trigger('sceneChange');

	},
	getSceneUrl () {

		return `${window.lp.globals.secureSiteURL + lp.ar.path}/#/scene/${this.model.get('Token')}`;

	},
	canvasChange () {

		$(window).on('mouseup touchend', () => {

			$(lp.ar).trigger('canvasChange');
			$(window).off('mouseup touchend');

		});

	},
	closeHelper (e) {

		$(e.target).closest('.item').hide();

	},
	closeHelper2 (e) {

		$('.boldchatPosition').hide();
		$(e.target).closest('.item').hide();

	},
	showConcurrencyModal () {

		const displayModal = function () {

			$('body').lpModal({
				onInit: true,
				width: 380,
				height: 120,
				openEvt () {

					$('#concurrencyConflict .latest').one('click', (e) => {

						e.preventDefault();
						Backbone.history.loadUrl();
						$('body').lpModalClose();

					});

				},
				appendContentToForm: false,
				content: $('#concurrencyConflict')
			});

		};

		// check if LpModal is currently open
		if ($('#lpModalContent').length) {

			$('body').lpModalResize({
				width: 380,
				height: 120
			});

			$('#lpModalContent').html(
				`<div id="concurrencyConflict" class="arPromptModal">${$('#concurrencyConflict').html()}</div>`
			);
			$('#concurrencyConflict .latest').one('click', (e) => {

				e.preventDefault();
				Backbone.history.loadUrl();
				$('body').lpModalClose();

			});

		} else {

			displayModal();

		}

	},
	showLimitModal () {

		$('body').lpModal({
			onInit: true,
			width: 360,
			height: 120,
			appendContentToForm: false,
			openEvt () {

				$('#limitReachedModal .dismiss').one('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

			},
			closeEvt () {

				Backbone.history.loadUrl();

			},
			content: $('#limitReachedModal')
		});

	},
	showMaxSceneModal () {

		// close any modal that is currently showing if one exists
		$('body').lpModalClose();

		$('body').lpModal({
			onInit: true,
			width: 360,
			height: 135,
			appendContentToForm: false,
			openEvt () {

				$('#userMaxSceneModal .dismiss').one('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

			},
			closeEvt () {

				Backbone.history.loadUrl();

			},
			content: $('#userMaxSceneModal')
		});

	},
	showRenameModal () {

		const that = this;

		$('body').lpModal({
			onInit: true,
			width: 350,
			height: 180,
			appendContentToForm: false,
			openEvt () {

				$('#renameModal .cancel').on('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

				$('#renameModal .save').on('click', (e) => {

					e.preventDefault();

					const name = $.trim($('#newRenameScene').val());

					// prevent empty submissions
					if (name) {

						that.model.rename(name, () => {

							$('body').lpModalClose();

						});

					}

				});

			},
			closeEvt () {

				const form = $('.arContainer .lpForm');
				$('#renameModal .cancel, #renameModal .save').off();
				$('#newRenameScene').val('');
				form.removeClass('error').find('label.error').html('');
				form.find('input').off();
				Backbone.history.loadUrl();

			},
			content: $('#renameModal')
		});

	},
	showInvalidSpritesDataModal () {

		$('body').lpModal({
			onInit: true,
			width: 320,
			height: 60,
			appendContentToForm: false,
			content: $('#invalidSpritesData')
		});

	},
	showError (options) {

		// if there is a modal open already
		if ($('#lpModalContent').length) {

			const form = $('#lpModalContent .lpForm');
			const input = form.find('input');
			const label = form.find('.validationMessage span');

			label.html(options.message).removeClass('valid').addClass('error');
			input.addClass('error');
			input.on('keypress', () => {

				input.removeClass('error');
				label.html('').addClass('valid').removeClass('error');

			});

		} else {

			// otherwise

			this.showRenameModal();

		}

	},
	sceneNotFound (options) {

		$(lp.ar).trigger('showHeaderError', options);

	},
	undo () {

		this.model.set('Products', lp.ar.canvas.undo[lp.ar.canvas.undo.length - 1], { silent: true });

		$(lp.ar).trigger('sceneChange');

		if (lp.ar.canvas.undo.length > 0) {

			lp.ar.canvas.undo.pop();

		} else {

			$(lp.ar).trigger('unsetUndo');

		}

		const selectedForUndo = lp.ar.canvas.getSelected();

		if (selectedForUndo) {

			trackViewInYourRoom({
				eventAction: 'Click-Undo Last Edit',
				eventLabel: selectedForUndo.element.shortSku || ''
			});

		}

		lp.ar.canvas.renderScene(this.model); // render the scene as it was before
		lp.ar.canvas.selectElement(false); // unselect all sprites

	},
	emailScene () {

		let hightValue = 0;
		const roomProducts = getShortSkuArrayForGa(this.model.get('Products'));

		if (window.lp.globals.isLoggedIn) {

			hightValue = 380;

		} else {

			hightValue = 700;

		}
		$('body').lpModal({
			onInit: true,
			lpModalClass: 'lpModal--alt1 emailToFriend',
			width: 500,
			height: hightValue,
			appendContentToForm: false,
			src: `${lp.ar.path}/EmailToFriend/`,
			afterOpenEvt () {

				const $element = document.querySelector('#lpModal.emailToFriend');
				if ($element) {

					$element.setAttribute('data-products', roomProducts);

				}

			}
		});

	},
	saveScene () {

		const that = this;

		trackViewInYourRoom({
			eventAction: 'Save-Editable',
			eventLabel: getShortSkuArrayForGa(that.model.get('Products'))
		});

		$('body').lpModal({
			onInit: true,
			width: 400,
			height: 250,
			appendContentToForm: false,
			openEvt () {

				// set the scene title in input box right from the start
				const saveRoomSceneName = document.getElementById('saveRoomSceneName');
				saveRoomSceneName.value = document
					.querySelector('.arPageTitle')
					.innerText.replace('edit', '')
					.replace('Rename', '');
				const submitFormBtn = document.getElementById('saveName');
				const saveRoomForm = $('#saveRoomForm');
				window.initFormValidation(false, saveRoomForm);
				$('#saveRoomSceneName').rules('add', {
					required: true,
					validRoomName: true
				});

				saveRoomForm.valid();

				$('#saveModal .cancel').on('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

				initBlockEnterKeyForDisabledButton(submitFormBtn);

				submitFormBtn.addEventListener('click', (e) => {

					e.preventDefault();
					const name = $.trim($('#saveRoomSceneName').val());
					// prevent empty submissions
					if (saveRoomForm.valid()) {

						const request = new Promise((resolve, reject) => {

							that.model.rename(
								name,
								() => {

									resolve();
									$('body').lpModalClose();

								},
								() => reject()
							);

						});

						setButtonStateDuringActivity(submitFormBtn, request);

					}

				});

			},
			closeEvt () {

				const form = $('.arContainer .lpForm');

				$('#saveModal .cancel, #saveModal .save').off();
				$('#saveRoomSceneName').val('');
				form.removeClass('error').find('label.error').html('');
				form.find('input').off();
				Backbone.history.loadUrl();

			},
			content: $('#saveModal')
		});

	},
	printScene () {

		const that = this;

		trackViewInYourRoom({
			eventAction: 'Click-Print',
			eventLabel: getShortSkuArrayForGa(that.model.get('Products'))
		});

		$('#helpers .item').hide(); // hide help icons
		$('.boldchatPosition').hide(); // hide chat button
		lp.ar.canvas.selectElement(false); // unselect all sprites

		$.ajax({
			url: '/api/myscenes/currentscene/operation/print',
			type: 'POST',
			success (data) {

				that.model.set('Products', data.Products, { silent: true });
				$(lp.ar).trigger('reloadFooter');
				$('#printModal .printWithPrices, #printModal .printWithoutPrices').removeClass('disabled');

			},
			error () {

				$(lp.ar).trigger('messageAlert', { message: 'Error', fast: false });

			}
		});

		$('body').lpModal({
			onInit: true,
			width: 500,
			height: 250,
			appendContentToForm: false,
			openEvt () {

				$('#printModal h1').text(lp.ar.SceneModelObj.get('SceneName'));

				$('#printModal .cancel').on('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

				$('#printModal .printWithPrices, #printModal .printWithoutPrices').on('click', function (e) {

					// disable printing if print api call isn't complete
					if ($(this).hasClass('disabled')) {

						return false;

					}

					// make sure to print with or without prices
					if ($(this).hasClass('printWithoutPrices')) {

						$('#arFooter, #arHeader').addClass('noPrices');

					} else {

						$('#arFooter, #arHeader').removeClass('noPrices');

					}

					e.preventDefault();
					$('body').lpModalClose();
					setTimeout(() => {

						window.print();

					}, 500);

				});

			},
			closeEvt () {

				$('#printModal .cancel, #printModal .printWithPrices, #printModal .printWithoutPrices').off();
				$('#printModal .printWithPrices, #printModal .printWithoutPrices').addClass('disabled');
				$('#arFooter').removeClass();

			},
			content: $('#printModal')
		});

	}
});

lp.ar.NoteItemView = Backbone.Marionette.ItemView.extend({
	template: '/augmented-reality/templates/note',
	ui: {
		roomNotes: '#roomNotes',
		roomNoteButtons: '.roomNoteButtons',
		saveRoomNote: '.saveRoomNote',
		deleteRoomNote: '.deleteRoomNote'
	},
	events: {
		'focus @ui.roomNotes': 'roomNotesFocus',
		'blur @ui.roomNotes': 'roomNotesBlur',
		'focus @ui.saveRoomNote': 'saveRoomNoteFocus',
		'blur @ui.saveRoomNote': 'saveRoomNoteBlur',
		'focus @ui.deleteRoomNote': 'deleteRoomNoteFocus',
		'blur @ui.deleteRoomNote': 'deleteRoomNoteBlur',
		'click @ui.saveRoomNote': 'saveRoomNoteClick',
		'click @ui.deleteRoomNote': 'deleteRoomNoteClick'
	},
	initialize () {

		$(lp.ar).on('showNoteError', (e, options) => this.showNoteErrorModal(options.message));

	},
	onRender () {

		initBlockEnterKeyForDisabledButton(this.ui.saveRoomNote[0]);
		initBlockEnterKeyForDisabledButton(this.ui.deleteRoomNote[0]);

	},
	showNoteErrorModal (errorMessage) {

		const $noteErrorModal = $('#noteErrorModal');
		const $noteErrorMsg = $('.noteErrorMsg', $noteErrorModal);

		$('body').lpModal({
			onInit: true,
			width: 400,
			height: 85,
			appendContentToForm: false,
			content: $noteErrorModal,
			openEvt () {

				$noteErrorMsg.html(errorMessage);

				$('.dismiss', $noteErrorModal).one('click', () => {

					$('body').lpModalClose();

				});

			},
			closeEvt () {

				$noteErrorMsg.html('');

			}
		});

	},
	delayHideRoomNoteButtons () {

		this.roomNotesTimeout = setTimeout(() => {

			this.ui.roomNoteButtons.slideUp('fast');
			this.forceSaveNote();

		}, 10);

	},
	clearRoomNoteTimeout () {

		clearTimeout(this.roomNotesTimeout);

	},
	roomNotesFocus () {

		this.clearRoomNoteTimeout();
		this.ui.roomNoteButtons.slideDown('fast');

	},
	roomNotesBlur () {

		this.delayHideRoomNoteButtons();

	},
	saveRoomNoteFocus () {

		this.clearRoomNoteTimeout();

	},
	saveRoomNoteBlur () {

		this.delayHideRoomNoteButtons();

	},
	deleteRoomNoteFocus () {

		this.clearRoomNoteTimeout();

	},
	deleteRoomNoteBlur () {

		this.delayHideRoomNoteButtons();

	},
	saveRoomNote (roomNote, buttonClicked) {

		const request = this.model.saveNote(roomNote, {
			successCallback: () => {

				this.render();

			}
		});

		if (buttonClicked) {

			setButtonStateDuringActivity(buttonClicked, request);

		}

	},
	saveRoomNoteClick (e) {

		e.preventDefault();

		if (!this.hasRoomNoteChanged()) {

			return;

		}

		this.saveRoomNote(this.ui.roomNotes.val(), e.target);

	},
	deleteRoomNoteClick (e) {

		const roomNote = this.ui.roomNotes[0];
		const roomNoteText = roomNote.value.trim();
		if (roomNoteText === '' && roomNote.defaultValue === '') {

			return;

		}

		this.saveRoomNote('', e.target);

	},
	forceSaveNote () {

		if (!this.hasRoomNoteChanged()) {

			return;

		}

		this.saveRoomNote(this.ui.roomNotes.val());

	},
	hasRoomNoteChanged () {

		const roomNote = this.ui.roomNotes[0];
		const roomNoteText = roomNote.value.trim();

		roomNote.value = roomNoteText; // set trimmed value

		return roomNoteText !== roomNote.defaultValue;

	}
});

lp.ar.FooterItemView = Backbone.Marionette.ItemView.extend({
	template: '/augmented-reality/templates/footer',
	className: 'footerWrapper',
	ui: {
		header: '.productListHeader',
		productCarousel: '#productCarousel',
		gliderContainer: '#productCarousel .glider-container',
		productImg: '#productCarousel .productImg',
		productImgs: '#productCarousel .productImg img',
		products: '#productCarousel .productItem',
		productBottomLink: '.productBottom__titleLink',
		addToCart: '.addAllCart',
		hideShowBtn: '.hideShowBtn'
	},
	events: {
		'click @ui.addToCart': 'addToCart',
		'click @ui.hideShowBtn': 'toggleProductVisibility'
	},
	initialize (options) {

		this.initialRender = options.initialRender;

	},
	onRender () {

		if (this.model.get('Products') && window.lp.globals.enableDataCapture) {

			const { reporter } = window.lp.dataCapture;

			this.model.get('Products').forEach((el) => {

				reporter.track({
					event: 'SkuView',
					hasAddToCart: '1',
					section: 'ViewInYourRoom',
					sku: el.ShortSku,
					skuInputType: el.SkuInputType
				});

			});

		}

		this.initCarousel();
		this.initialRender = false;

	},
	templateHelpers () {

		let totalQty = 0;
		const minShippingPrice = this.model.get('MinShippingPrice') || '-';

		function freeShippingReturns (item) {

			let text = '';
			const shippingOptions = item.ShippingOptions || [];

			const shippingOptionsEnum = {
				None: 0,
				// Default shipping (to the USA)
				FreeShipping: 1,
				FreeShippingAndFreeReturns: 2,
				FreeShippingToStatesWithStores: 3,
				FreeShippingOverMinimum: 4,
				FreeShippingToStatesWithStoresOverMinimum: 5
			};

			if (shippingOptions.indexOf(shippingOptionsEnum.FreeShippingAndFreeReturns) > -1) {

				text = 'Free Shipping &amp; Free Returns*';

			} else if (shippingOptions.indexOf(shippingOptionsEnum.FreeShipping) > -1) {

				text = 'Free Shipping*';

			} else if (shippingOptions.indexOf(shippingOptionsEnum.FreeShippingToStatesWithStores) > -1) {

				text = 'Ships Free to States With Stores';

			} else if (shippingOptions.indexOf(shippingOptionsEnum.FreeShippingToStatesWithStoresOverMinimum) > -1) {

				text = `Ships Free Within State - ${formatCurrency(minShippingPrice)}Min. Order`;

			} else if (shippingOptions.indexOf(shippingOptionsEnum.FreeShippingOverMinimum) > -1) {

				text = `Ships Free with Orders Over ${formatCurrency(minShippingPrice)}`;

			} else {

				text = '';

			}

			return text;

		}

		function priceTypeText (item) {

			if (item.IsOnSale) {

				return 'Sale';

			}
			if (item.IsOnClearance) {

				return 'Clearance';

			}
			if (item.DisplayPriceType === lp.ar.priceType.SpecialMember) {

				return 'Member Special';

			}

			return '';

		}
		function showPriceSaved (item) {

			if (
				item.SavedPrice !== 0
				&& (item.IsOnSale || item.IsOnClearance || item.DisplayPriceType == lp.ar.priceType.SpecialMember)
			) {

				return true;

			}

			return false;

		}

		_.each(this.model.get('Products'), (item) => {

			// calculate total quantity of products
			totalQty += item.Quantity;

			// Template Helpers for each product
			item.hightlightPrice = item.IsOnSale || item.IsOnClearance || item.IsOnClearanceOrSale || item.IsSpecial;
			item.memberPrice = item.DisplayPriceType !== 0;
			item.freeShippingReturns = freeShippingReturns(item);
			item.priceTypeText = priceTypeText(item);
			item.showPriceSaved = showPriceSaved(item);

		});

		this.flattenedProductList = this.flattenedProducts();

		return {
			totalQty,
			LastSearch: window.lp.globals.lastSearchURL,
			isHospitality: window.lp.globals.isHospitality,
			initialRender: this.initialRender,
			flattenedProducts: this.flattenedProductList
		};

	},
	initCarousel () {

		if (this.ui.gliderContainer.length > 0) {

			const style = window.getComputedStyle(this.ui.productCarousel.get(0));
			const margins = parseFloat(style.getPropertyValue('--carousel-product-margin')) * 2;
			const breakpointMedium = parseInt(style.getPropertyValue('--carousel-breakpoint-medium'), 10);
			const breakpointLarge = parseInt(style.getPropertyValue('--carousel-breakpoint-large'), 10);
			const itemWidthSmall = parseFloat(style.getPropertyValue('--carousel-product-size-small')) + margins;
			const itemWidthMedium = parseFloat(style.getPropertyValue('--carousel-product-size-medium')) + margins;
			const itemWidthLarge = parseFloat(style.getPropertyValue('--carousel-product-size-large')) + margins;

			// Glider needs slidesToShow option to be 'auto' if itemWidth option is set but it will still essentially
			// end up to be 5 based on itemWidth and the computed #productCarousel width at different breakpoints
			const gliderOptions = {
				slidesToShow: 'auto',
				slidesToScroll: CAROUSEL_SLIDESTOSHOW,
				itemWidth: itemWidthSmall,
				dots: false,
				rewind: false,
				duration: 0,
				arrows: {
					prev: '#productCarousel .glider-prev',
					next: '#productCarousel .glider-next'
				},
				responsive: [
					{
						breakpoint: breakpointMedium,
						settings: { itemWidth: itemWidthMedium }
					},
					{
						breakpoint: breakpointLarge,
						settings: { itemWidth: itemWidthLarge }
					}
				]
			};

			const that = this;
			const element = this.ui.gliderContainer.get(0);

			// If there were 2 slides (6 items) and 1 item was removed to become just 1 slide, reset currentIndex
			if (this.flattenedProductList.length <= CAROUSEL_SLIDESTOSHOW || typeof this.currentIndex === 'undefined') {

				this.currentIndex = 0;

			}

			element.addEventListener('glider-loaded', function () {

				const glider = LPGlider(this);
				glider.setActiveSlide(that.currentIndex);
				that.toggleSlideElementsTabIndex();

			});

			if (this.gliderInstance) {

				this.gliderInstance.destroy();

			}

			this.gliderInstance = new LPGlider(element, gliderOptions);

			this.gliderInstance.ele.addEventListener('glider-slide-visible', () => {

				that.currentIndex = that.gliderInstance.slide;
				that.toggleSlideElementsTabIndex();

			});

		}

	},
	toggleSlideElementsTabIndex () {

		const toggleTabIndex = (element, isSet) => {

			if (isSet) {

				element.setAttribute('tabindex', '-1');
				element.setAttribute('aria-hidden', true);

			} else {

				element.removeAttribute('tabindex');
				element.removeAttribute('aria-hidden');

			}

		};

		if (this.currentIndex === 0) {

			const hiddenElementIndex = this.currentIndex + CAROUSEL_SLIDESTOSHOW;
			this.ui.hideShowBtn.each((index, element) => toggleTabIndex(element, (index + 1) / 2 > hiddenElementIndex));
			this.ui.productBottomLink.each((index, element) => toggleTabIndex(element, index >= hiddenElementIndex));

		} else {

			this.ui.hideShowBtn.each((index, element) => toggleTabIndex(element, (index + 1) / 2 <= this.currentIndex));
			this.ui.productBottomLink.each((index, element) => toggleTabIndex(element, index < this.currentIndex));

		}

	},
	flattenedProducts () {

		return (this.model.get('Products') || []).reduce((acc, product) => {

			// flatten duplicate items (with same SKU) into its own product
			product.ProductSprites.forEach((_, i, arr) => {

				const spriteCount = arr.length;
				if (spriteCount > 1) {

					const temp = { ...product };
					temp.ProductSprites = [ ...arr ].splice(i, 1);
					temp.Quantity = 1;
					// For creating unique alt text to avoid redundant link Accessibility issue
					temp.SpriteCounter = ` ${i + 1} of ${spriteCount}`;
					acc.push(temp);

				} else {

					acc.push(product);

				}

			});

			return acc;

		}, []);

	},
	addToCart (e) {

		const products = [];
		const $el = $(e.target).closest('.addAllCart');
		const { reporter } = window.lp.dataCapture;
		const button = $el.get(0);
		const testCompositionId =			(window.utag_data.testcomposition_id && window.utag_data.testcomposition_id[0]) || null;

		let totalQtyToAdd = 0;
		let totalPriceToAdd = 0;

		this.model.get('Products').forEach((el) => {

			const {
				Quantity, ShortSku, ProductName, DisplayPrice, Category, SkuInputType
			} = el;
			products.push({
				Quantity,
				ShortSku,
				TestCompositionId: testCompositionId,
				Name: ProductName,
				Price: DisplayPrice,
				Category,
				SkuInputType
			});

			totalQtyToAdd += Quantity;
			totalPriceToAdd += Quantity * DisplayPrice;

		});

		const request = addToCart({
			arrData: products,
			successCallback: redirectToCart,
			errorCallback: (errors, xhr, response) => {

				showAddToCartFailureModal({
					cartStatus: errors,
					response,
					fromModal: false
				});

			}
		});

		if (window.lp.globals.enableDataCapture) {

			reporter.trackAddToCart(products, button);

		}

		if (window.top.DY) {

			try {

				trackAddToCartDy(products[0].ShortSku, parseFloat(totalPriceToAdd.toFixed(2)), totalQtyToAdd);

			} catch (e) {

				console.warn('DY API is not available', e);

			}

		}

		addClassDuringActivity(button, 'loading noPointerEvents disabled', request);

	},
	toggleProductVisibility (e) {

		const { currentTarget } = e;
		const { firstElementChild } = currentTarget;
		const spriteId = Number(currentTarget.dataset.spriteId);
		const isHidden = firstElementChild.classList.contains('hideShowBtn--hide');
		const productItem = firstElementChild.closest('.productItem');

		// Update IsHidden in the model
		lp.ar.canvas.updateIsHiddenState({
			spriteId,
			isHidden,
			model: this.model,
			skipRenderFooter: true // Skip re-rendering itself to avoid flicker while clicking Show/Hide
		});

		// Update UI manually since we're not re-rendering footer view
		const selectedElement = lp.ar.canvas.getSelectedBySpriteId(spriteId);
		if (selectedElement) {

			if (isHidden) {

				selectedElement.hide();
				selectedElement.isHidden = true;
				lp.ar.canvas.selectElement(false);

			} else {

				selectedElement.show();
				selectedElement.isHidden = false;
				lp.ar.canvas.selectElement(selectedElement.id);

			}

			productItem.classList.toggle('hiddenItem');

		}

	}
});
